// ==================================================================================================
//  TECH DEBT: THIS CODE WAS TAKEN FROM https://github.com/tombolaltd/javascript-arcade
//             AND SHOULD BE REPLACED WITH A SUITABLE NPM PACKAGE ONCE AVAILABLE
// ==================================================================================================
import 'pixi-spine';
import { spine, Text, TextStyle } from 'pixi.js';
import { Slide } from '@/components/arcade-game/_components/how-to-play/_domain/slider';

const TEXT_STYLE: TextStyle = new TextStyle({
    fontSize: 24,
    fill: '#1DBBAC'
});

const slideStrings = [
  'Select your stake and tap \'buy\' to play',
  'Match 3 or 4 in a row to win',
  '10 win lines and a bonus round'
];

class HowToPlaySlide extends Slide {
  public animation: spine.Spine;
  private transitionSlideInCallback: (delay: number, isAutoPlayTransition: boolean) => void;
  private transitionSlideLeftCallback: (isAutoPlayTransition: boolean) => void;
  public slideIndex: number;
  private info: Text;
  private transitionInDelay: number;

  constructor(skeleton: spine.core.SkeletonData) {
    super();
    this.animation = new spine.Spine(skeleton);
    this.addChild(this.animation);

    this.info = new Text('', TEXT_STYLE);
    this.info.anchor.set(0.5);
    this.addChild(this.info);

    this.animation.skeleton.setToSetupPose();
    this.animation.autoUpdate = true;

    this.transitionInDelay = 0;
  }

  public initSlide(): void {
    this.info.text = slideStrings[this.slideIndex];
  }

  public onAnimationComplete(): void {
    this.transitionSlideLeftCallback(true);
    this.transitionSlideInCallback(this.transitionInDelay, true);
  }

  public setCallbacks(transitionSlideInCallback: () => void, transitionSlideLeftCallback: (autoPlay: boolean) => void, slideIndex: number): Promise<void> {
    return new Promise((resolve) => {
      this.transitionSlideInCallback = transitionSlideInCallback;
      this.transitionSlideLeftCallback = transitionSlideLeftCallback;
      this.slideIndex = slideIndex;

      return resolve();
    });
  }

  public play(): void {
    this.animation.state.setAnimation(this.slideIndex, 'animation', false);

    this.animation.state.tracks[this.slideIndex].listener = {
      complete: this.onAnimationComplete.bind(this)
    };
  }

  public handleOrientationChange(slideWidth: number, slideHeight: number, yPosition: number): void {
    this.info.style.fontSize = slideHeight * 0.15;
    this.info.position.y = slideHeight * 0.5;

    this.position.y = yPosition;
  }
}

export { HowToPlaySlide };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/arcade-game/_components/how-to-play/_domain/animations/htp-slide.ts